<template>
  <div class="md-layout">
    <BinnacleEntriesExtranet
      ref="binnacle-timeline"
      :entries="binnacleEntries"
      :submitting="submitting"
      :taggableUsers="taggableUsers"
      :show-new-comment-input="$canView('Sinister', 'binnacle')"
      :add-new-comment-input="$canAdd('Sinister', 'binnacle')"
      @update:newComment="addComment"
    />
  </div>
</template>

<script>
import DefaultAvatar from '@/assets/images/default-avatar.png'
import usesAccountInfoMixin from '@/mixins/usesAccountInfo'
import extranetService from '@/services/extranet'
import { mapState } from 'vuex';
import { BinnacleEntriesExtranet } from '@/components'
import { adaptBinnacleEntries } from './utils'

import sinisterService from '@/services/sinister'

const entryIcons = {
  info: 'card_travel',
  danger: 'flight_land',
  [null]: 'extension'
}

export default {
  name: "Binnacle",

  components: {
    BinnacleEntriesExtranet
  },

  props: {
    affectedId: {
      type: [Number, String],
      required: true
    }
  },

  mixins: [usesAccountInfoMixin],

  data() {
    return {
      responsive: false,
      submitting: false,
      binnacle: [],
      taggableUsers: [],
    };
  },
  computed: {
    ...mapState(['account']),
    simpleTimeline() {
      if (this.responsive) {
        return "simple";
      }
      return "";
    },

    avatar() {
      const account = this.account
      const avatar = account && account.avatar
      return avatar || DefaultAvatar
    },
    binnacleEntries() {
      return adaptBinnacleEntries(this.binnacle)
    }
  },
  methods: {
    fetchBinnacle() {
      return Promise.all([sinisterService.fetchBinnacle(this.affectedId), extranetService.fetchTaggableUsers()])
        .then(res => {
          this.binnacle = res[0]
          this.taggableUsers = res[1].filter(({fullName}) => !!fullName)
        })
    },
    addComment(note, mentionedUsers = []) {
      const newEntry = {
        user: `${this.account.firstName} ${this.account.lastName}`,
        note,
        type: 'info',
        mentionedUsers
      }
      this.submitting = true
      return sinisterService.createBinnacle(this.affectedId, newEntry)
        .then((newEntry) => {
          this.binnacle.push(newEntry)
          this.$refs['binnacle-timeline'].reset()
        }).finally(() => {
          this.submitting = false
        })
    }
  },
  watch: {
    affectedId: {
      immediate: true,
      handler: 'fetchBinnacle',
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  display: flex;
  width: 150%;
  transform: translate(10%, 0%);
}
.time-content {
  font-size: 16px;
}

.binnacle {
  margin-top: 0px;
}

.binnacle-entry {
  margin-bottom: 4px;
}

.binnacle-entry > .timeline-panel {
  margin-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/File/Binnacle.vue